/* tslint:disable */
// Generated using typescript-generator version 2.12.476 on 2026-09-13 23:17:47.

export interface ModuleAttributeConverter extends AttributeConverter<Module, string> {
}

export interface AttributeConverter<X, Y> {
}

export enum BillPaymentType {
    BILL = "BILL",
    INTERMEDIATE_BILL = "INTERMEDIATE_BILL",
    CASH = "CASH",
}

export enum EntryTable {
    CONSULTATION = "CONSULTATION",
    COST_ESTIMATION = "COST_ESTIMATION",
    BLOCK_PROCEDURE = "BLOCK_PROCEDURE",
}

export enum QuantityValidationErrorMessage {
    NOT_VALID_FOR_ELECTRONIC_DATA_TRANSFER = "NOT_VALID_FOR_ELECTRONIC_DATA_TRANSFER",
    OBLIGATORY = "OBLIGATORY",
    X_QUANTITY_PER_PROCEDURE = "X_QUANTITY_PER_PROCEDURE",
    X_QUANTITY_IN_ONE_DAY = "X_QUANTITY_IN_ONE_DAY",
    X_QUANTITY_IN_X_DAYS = "X_QUANTITY_IN_X_DAYS",
    X_QUANTITY_IN_ONE_WEEK = "X_QUANTITY_IN_ONE_WEEK",
    X_QUANTITY_IN_ONE_MONTH = "X_QUANTITY_IN_ONE_MONTH",
    X_QUANTITY_IN_ONE_YEAR = "X_QUANTITY_IN_ONE_YEAR",
    X_QUANTITY_PER_PATIENT = "X_QUANTITY_PER_PATIENT",
    X_QUANTITY_PER_CONSULTATION = "X_QUANTITY_PER_CONSULTATION",
    X_QUANTITY_PER_TREATMENT = "X_QUANTITY_PER_TREATMENT",
}

export enum QuantityValidationErrorType {
    HAS_ALL_REMAINING = "HAS_ALL_REMAINING",
    HAS_SOME_REMAINING = "HAS_SOME_REMAINING",
    HAS_NO_REMAINING = "HAS_NO_REMAINING",
}

export enum InterventionBookingTestResult {
    POSITIVE = "POSITIVE",
    POOL_POSITIVE = "POOL_POSITIVE",
    NEGATIVE = "NEGATIVE",
    UNCERTAIN = "UNCERTAIN",
    BORDERLINE = "BORDERLINE",
}

export enum ProcedureCategory {
    PROCEDURE = "PROCEDURE",
    MEDICAMENT = "MEDICAMENT",
    MATERIAL = "MATERIAL",
    BLOCK_PROCEDURE = "BLOCK_PROCEDURE",
    COST_ESTIMATION = "COST_ESTIMATION",
    COST_ESTIMATION_PROCEDURE = "COST_ESTIMATION_PROCEDURE",
    COST_ESTIMATION_MEDICAMENT = "COST_ESTIMATION_MEDICAMENT",
    PROCEDURE_GROUP = "PROCEDURE_GROUP",
}

export enum SearchBy {
    CODE = "CODE",
    DESCRIPTION = "DESCRIPTION",
    SHORT_DESC = "SHORT_DESC",
    ALL = "ALL",
}

export enum OneTimePasswordExpiration {
    VALID = "VALID",
    ALMOST_EXPIRED = "ALMOST_EXPIRED",
    EXPIRED = "EXPIRED",
}

export enum AnamnesisSeverity {
    VERY_LOW = "VERY_LOW",
    LOW = "LOW",
    MEDIUM = "MEDIUM",
    HIGH = "HIGH",
    VERY_HIGH = "VERY_HIGH",
}

export enum QuestionType {
    SINGLE_ANSWER = "SINGLE_ANSWER",
    MULTI_ANSWER = "MULTI_ANSWER",
    FREE_TEXT = "FREE_TEXT",
    YES_NO = "YES_NO",
}

export enum AuthorityNotificationStatus {
    NA = "NA",
    NOTIFIED = "NOTIFIED",
}

export enum ComponentValueEntryPoint {
    CHECK_IN = "CHECK_IN",
    CHECK_OUT = "CHECK_OUT",
    TEST_RESULT = "TEST_RESULT",
}

export enum CovidTestSampleMethod {
    NONE = "NONE",
    SALIVA = "SALIVA",
    NASAL_SWAB = "NASAL_SWAB",
    THROAT_SWAB = "THROAT_SWAB",
    VAGINAL_SWAB = "VAGINAL_SWAB",
    URINE = "URINE",
    BLOOD_SERUM = "BLOOD_SERUM",
}

export enum InterventionBookingInputChannel {
    PHONE = "PHONE",
    MIPOCO = "MIPOCO",
    TEST_AND_FLY = "TEST_AND_FLY",
}

export enum InterventionBookingScheduleMode {
    WALK_IN = "WALK_IN",
    WAIT_LIST = "WAIT_LIST",
    APPOINTMENT = "APPOINTMENT",
}

export enum InterventionBookingSearchBy {
    ENTRY_DATE = "ENTRY_DATE",
    APPOINTMENT_DATE = "APPOINTMENT_DATE",
    COVID_TEST = "COVID_TEST",
    VACCINATION = "VACCINATION",
}

export enum InterventionBookingStatus {
    REQUESTED = "REQUESTED",
    ON_WAIT_LIST = "ON_WAIT_LIST",
    PLANNED = "PLANNED",
    EXECUTED = "EXECUTED",
    AWAITING_COMPLETION = "AWAITING_COMPLETION",
    LAB_RECEIVED = "LAB_RECEIVED",
    ON_HOLD = "ON_HOLD",
    RESULTED = "RESULTED",
    VERIFIED = "VERIFIED",
    COMPLETED = "COMPLETED",
    CONTROLLED_BY = "CONTROLLED_BY",
    CANCELLED = "CANCELLED",
    RESULT_REJECTED = "RESULT_REJECTED",
}

export enum InterventionExternalCode {
    PCR_SALIVA_TEST = "PCR_SALIVA_TEST",
    PCR_SALIVA_TEST_INDIVIDUAL_TEST = "PCR_SALIVA_TEST_INDIVIDUAL_TEST",
    RAPID_SALIVA_TEST = "RAPID_SALIVA_TEST",
    COVID_CERTIFICATE_OF_RECOVERY = "COVID_CERTIFICATE_OF_RECOVERY",
    COVID_CERTIFICATE_OF_VACCINATION = "COVID_CERTIFICATE_OF_VACCINATION",
    COVID_CERTIFICATE_EXTERNAL_TEST_DOCUMENT = "COVID_CERTIFICATE_EXTERNAL_TEST_DOCUMENT",
    VACCINATION_DOSE_1 = "VACCINATION_DOSE_1",
    VACCINATION_DOSE_2 = "VACCINATION_DOSE_2",
    VACCINATION_CHILD_DOSE_1 = "VACCINATION_CHILD_DOSE_1",
    VACCINATION_CHILD_DOSE_2 = "VACCINATION_CHILD_DOSE_2",
    VACCINATION_SINGLE_DOSE = "VACCINATION_SINGLE_DOSE",
    VACCINATION_BOOSTER = "VACCINATION_BOOSTER",
    HPV_TEST = "HPV_TEST",
    CLINICAL_QUESTIONS_TEST = "CLINICAL_QUESTIONS_TEST",
    CHLAMYDIA_TEST = "CHLAMYDIA_TEST",
    TRICHOMONIASIS_TEST = "TRICHOMONIASIS_TEST",
    RSV_TEST = "RSV_TEST",
    INFLUENZA_TEST = "INFLUENZA_TEST",
    HEPATITIS_B_TEST = "HEPATITIS_B_TEST",
    QUANTITY_TEST = "QUANTITY_TEST",
    ORDER_ITEM_TEST = "ORDER_ITEM_TEST",
    OTHER = "OTHER",
}

export enum InterventionInvoiceStatus {
    CREATED = "CREATED",
    DELETED = "DELETED",
}

export enum InterventionSlotStatus {
    FREE = "FREE",
    BOOKED = "BOOKED",
    BLOCKED = "BLOCKED",
}

export enum InterventionType {
    DEFAULT = "DEFAULT",
    COVID_TEST = "COVID_TEST",
    COVID_VACCINATION = "COVID_VACCINATION",
}

export enum LabTestDetectedResultType {
    POSITIVE = "POSITIVE",
    POOL_POSITIVE = "POOL_POSITIVE",
    NEGATIVE = "NEGATIVE",
    UNCERTAIN = "UNCERTAIN",
    BORDERLINE = "BORDERLINE",
}

export enum LabTestResultType {
    POSITIVE_NEGATIVE_CT = "POSITIVE_NEGATIVE_CT",
    POSITIVE_NEGATIVE_UNCERTAIN_CT = "POSITIVE_NEGATIVE_UNCERTAIN_CT",
    POSITIVE_NEGATIVE_BORDERLINE_MOC = "POSITIVE_NEGATIVE_BORDERLINE_MOC",
    QUANTITY_DECIMAL = "QUANTITY_DECIMAL",
    QUANTITY_DATE = "QUANTITY_DATE",
    TEXT = "TEXT",
}

export enum PoolSearchFilter {
    POOL = "POOL",
    POOL_NOT_SINGULARIZED = "POOL_NOT_SINGULARIZED",
    POOL_MEMBER = "POOL_MEMBER",
    POOL_OR_POOL_MEMBER = "POOL_OR_POOL_MEMBER",
    NON_POOL = "NON_POOL",
    SINGULARIZED_TEST = "SINGULARIZED_TEST",
}

export enum TestDateSearchBy {
    BOOKING_DATE = "BOOKING_DATE",
    APPOINTMENT_DATE = "APPOINTMENT_DATE",
    CHECK_IN_DATE = "CHECK_IN_DATE",
    LAB_RECEIVED_DATE = "LAB_RECEIVED_DATE",
    RESULT_DATE = "RESULT_DATE",
    RESULT_VERIFIED_DATE = "RESULT_VERIFIED_DATE",
}

export enum TestFrequency {
    WEEK_ONE = "WEEK_ONE",
    WEEK_TWO = "WEEK_TWO",
    MONTH_ONE = "MONTH_ONE",
    MONTH_TWO = "MONTH_TWO",
}

export enum TestRegistrationType {
    CENTRAL = "CENTRAL",
    EMPLOYEE = "EMPLOYEE",
}

export enum ConfirmationStatusType {
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
}

export enum ContractDocumentType {
    TERMS_OF_SERVICE = "TERMS_OF_SERVICE",
    DATA_PROTECTION = "DATA_PROTECTION",
}

export enum EmployeeAccessTokenType {
    PERSON = "PERSON",
    COMPANY = "COMPANY",
    PERSON_SELF_ONBOARDED = "PERSON_SELF_ONBOARDED",
    ONBOARDING_PERSON = "ONBOARDING_PERSON",
    ONBOARDING_COMPANY = "ONBOARDING_COMPANY",
}

export enum RegistrationStateType {
    INITIAL = "INITIAL",
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    REJECTED = "REJECTED",
}

export enum RepetitiveTestingMode {
    DEFAULT = "DEFAULT",
    FORCE_PARENT_GUARANTOR_PAYER = "FORCE_PARENT_GUARANTOR_PAYER",
    SELF_PAYER = "SELF_PAYER",
    OUTBREAK_TESTING = "OUTBREAK_TESTING",
}

export enum TestPoolingType {
    NONE = "NONE",
    BY_MISANTO = "BY_MISANTO",
    BY_COMAPNY = "BY_COMAPNY",
    BY_LABORATORY = "BY_LABORATORY",
}

export enum AlternativeTaxPointGroup {
    HSK_2407 = "HSK_2407",
    SANTESWISS_2410 = "SANTESWISS_2410",
}

export enum AnalyzerTestMethod {
    RT_PCR = "RT_PCR",
    PCR = "PCR",
    RT_PCR_NAT = "RT_PCR_NAT",
    PCR_NAT = "PCR_NAT",
    NAT = "NAT",
    ISOTHERMAL_AMPLIFICATION = "ISOTHERMAL_AMPLIFICATION",
}

export enum AutomaticPaymentStatus {
    IN_PROGRESS = "IN_PROGRESS",
    FINISHED = "FINISHED",
    ERROR = "ERROR",
}

export enum BillJournalOrderBy {
    BILL_NUMBER = "BILL_NUMBER",
    PATIENT_NAME = "PATIENT_NAME",
    OVERDUE = "OVERDUE",
}

export enum BillPrintOption {
    BILL_PREVIEW = "BILL_PREVIEW",
    PROOF_LIST = "PROOF_LIST",
}

export enum BillReceiver {
    PATIENT = "PATIENT",
    GUARANTOR = "GUARANTOR",
}

export enum BillSearchBy {
    BILL_NUMBER = "BILL_NUMBER",
    CURRENT_PATIENT = "CURRENT_PATIENT",
    AMOUNT = "AMOUNT",
    DATE = "DATE",
}

export enum BillStatus {
    OPEN = "OPEN",
    BILL = "BILL",
    INTERMEDIATE_BILL = "INTERMEDIATE_BILL",
    STORNO = "STORNO",
    PAID_OPEN = "PAID_OPEN",
    PAID_CLOSED = "PAID_CLOSED",
}

export enum BillType {
    NORMAL = "NORMAL",
    COLLECTIVE = "COLLECTIVE",
    PART_OF_COLLECTIVE = "PART_OF_COLLECTIVE",
}

export enum BillXmlRequestType {
    INVOICE = "INVOICE",
    REMINDER_1 = "REMINDER_1",
    REMINDER_2 = "REMINDER_2",
    REMINDER_3 = "REMINDER_3",
}

export enum BillXmlResponseStatus {
    PROCESSED = "PROCESSED",
    STORNO = "STORNO",
    ARCHIVED = "ARCHIVED",
}

export enum BillXmlResponseType {
    REJECTED = "REJECTED",
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    CONFIRMED = "CONFIRMED",
}

export enum BillXmlStatus {
    GENERATED = "GENERATED",
    TRANSMITTED = "TRANSMITTED",
    TRANSMISSION_ERROR = "TRANSMISSION_ERROR",
    CONFIRMED = "CONFIRMED",
    REJECTED_ARCHIVED = "REJECTED_ARCHIVED",
    REJECTED_STORNO = "REJECTED_STORNO",
    CANCELLED = "CANCELLED",
}

export enum BillXmlType {
    TARMED = "TARMED",
    DENTACONT = "DENTACONT",
}

export enum BillXmlVersion {
    TARMED_400 = "TARMED_400",
    TARMED_440 = "TARMED_440",
    TARMED_450 = "TARMED_450",
    TARDOC_500 = "TARDOC_500",
    DENTACONT = "DENTACONT",
}

export enum CivilStatus {
    UNKNOWN = "UNKNOWN",
    SINGLE = "SINGLE",
    MARRIED = "MARRIED",
    WIDOWED = "WIDOWED",
    DIVORCED = "DIVORCED",
    SEPARATED = "SEPARATED",
    PARTNERED = "PARTNERED",
}

export enum CompanySubType {
    PRIMARY_SCHOOL = "PRIMARY_SCHOOL",
    SECONDARY_SCHOOL = "SECONDARY_SCHOOL",
    HIGH_SCHOOL = "HIGH_SCHOOL",
    UNIVERSITY = "UNIVERSITY",
    OTHER = "OTHER",
}

export enum CompanyType {
    COMPANY = "COMPANY",
    SCHOOL = "SCHOOL",
    RETIREMENT_HOME = "RETIREMENT_HOME",
    ASSOCIATION = "ASSOCIATION",
    ADMINISTRATION = "ADMINISTRATION",
    HOSPITAL = "HOSPITAL",
    SOCIAL_MEDICINE = "SOCIAL_MEDICINE",
}

export enum CovidAnalyzerType {
    COBAS = "COBAS",
    DMX = "DMX",
}

export enum CreatorType {
    ADMINISTRATION = "ADMINISTRATION",
    CLIENT_ADMIN = "CLIENT_ADMIN",
    CLIENT_USER = "CLIENT_USER",
    USAGE = "USAGE",
    AI = "AI",
}

export enum DayStatisticsOptions {
    TURN_OVER = "TURN_OVER",
    PENDING_WORK = "PENDING_WORK",
    PROCEDURES_PROTOCOL = "PROCEDURES_PROTOCOL",
}

export enum Diagnosis {
    CLEAR_TEXT = "CLEAR_TEXT",
    CODED = "CODED",
    SUPPRESSED = "SUPPRESSED",
}

export enum DiseaseOrAgent {
    COVID_19 = "COVID_19",
}

export enum DocumentCopiesSearchBy {
    BILL_NUMBER = "BILL_NUMBER",
    CURRENT_PATIENT = "CURRENT_PATIENT",
    AMOUNT = "AMOUNT",
    BILL_DATE = "BILL_DATE",
    REMINDER_DATE = "REMINDER_DATE",
    BILL_GUARANTOR = "BILL_GUARANTOR",
}

export enum DocumentStatusCode {
    UNKNOWN = "UNKNOWN",
    ARRIVED = "ARRIVED",
    PROCESSING = "PROCESSING",
    COMPLETE_NOT_COLLECTED = "COMPLETE_NOT_COLLECTED",
    CANCELLED = "CANCELLED",
    COMPLETE = "COMPLETE",
    ADDRESS_MISSING = "ADDRESS_MISSING",
    NOT_DELIVERABLE = "NOT_DELIVERABLE",
}

export enum DocumentType {
    BILL = "BILL",
    REMINDER1 = "REMINDER1",
    REMINDER2 = "REMINDER2",
    REMINDER3 = "REMINDER3",
}

export enum EmailConsentType {
    NOT_CONTACTED = "NOT_CONTACTED",
    REQUEST_INITIATED = "REQUEST_INITIATED",
    REQUEST_SENT = "REQUEST_SENT",
    PATIENT_OPT_IN = "PATIENT_OPT_IN",
    PATIENT_OPT_OUT = "PATIENT_OPT_OUT",
    FORCED_OPT_IN = "FORCED_OPT_IN",
    FORCED_OPT_OUT = "FORCED_OPT_OUT",
    REQUEST_ERROR = "REQUEST_ERROR",
}

export enum EmergencyType {
    NO_EMERGENCY = "NO_EMERGENCY",
    VISIT = "VISIT",
    PHONE = "PHONE",
    BIRTH = "BIRTH",
}

export enum EpPrivilege {
    CMD_FILE = "CMD_FILE",
    CMD_PATIENT_MENU = "CMD_PATIENT_MENU",
    CMD_PATIENT = "CMD_PATIENT",
    CMD_PATIENT_SELECTION_BY_NAME = "CMD_PATIENT_SELECTION_BY_NAME",
    CMD_PATIENT_SELECTION_BY_NUMBER = "CMD_PATIENT_SELECTION_BY_NUMBER",
    CMD_PATIENT_NEW = "CMD_PATIENT_NEW",
    CMD_PATIENT_EDIT = "CMD_PATIENT_EDIT",
    CMD_PATIENT_BILL_INFORMATION = "CMD_PATIENT_BILL_INFORMATION",
    CMD_PATIENT_LETTER = "CMD_PATIENT_LETTER",
    CMD_PATIENT_DOCUMENTS = "CMD_PATIENT_DOCUMENTS",
    CMD_PATIENT_COST_ESTIMATE = "CMD_PATIENT_COST_ESTIMATE",
    CMD_PATIENT_RECALL = "CMD_PATIENT_RECALL",
    CMD_PATIENT_BESTATIGUNG = "CMD_PATIENT_BESTATIGUNG",
    CMD_PATIENT_DATA_EXPORT = "CMD_PATIENT_DATA_EXPORT",
    CMD_GURANTOR_MENU = "CMD_GURANTOR_MENU",
    CMD_GURANTOR = "CMD_GURANTOR",
    CMD_GURANTOR_UPDATE = "CMD_GURANTOR_UPDATE",
    CMD_DOCTOR = "CMD_DOCTOR",
    CMD_DOCTOR_UPDATE = "CMD_DOCTOR_UPDATE",
    CMD_MANDATE = "CMD_MANDATE",
    CMD_TARIFF_MENU = "CMD_TARIFF_MENU",
    CMD_TARIFF_TYPES = "CMD_TARIFF_TYPES",
    CMD_TARIFF_PROCEDURESELECTION = "CMD_TARIFF_PROCEDURESELECTION",
    CMD_TARIFF_PROCEDURES = "CMD_TARIFF_PROCEDURES",
    CMD_TARIFF_TARMED_PROCEDURES = "CMD_TARIFF_TARMED_PROCEDURES",
    CMD_TARIFF_PROCEDURESCONVERSION = "CMD_TARIFF_PROCEDURESCONVERSION",
    CMD_TARIFF_TAX_POINT_VALUE = "CMD_TARIFF_TAX_POINT_VALUE",
    CMD_MEDICINES = "CMD_MEDICINES",
    CMD_MEDICINE_MATERIALS = "CMD_MEDICINE_MATERIALS",
    CMD_MEDICINE_SELECTION = "CMD_MEDICINE_SELECTION",
    CMD_MEDICAMENTGROUP = "CMD_MEDICAMENTGROUP",
    CMD_DOSAGE = "CMD_DOSAGE",
    CMD_SUPPLIER = "CMD_SUPPLIER",
    CMD_STOCK_ADMINISTRATION = "CMD_STOCK_ADMINISTRATION",
    CMD_ORDER_ADMINISTRATION = "CMD_ORDER_ADMINISTRATION",
    CMD_ORDER = "CMD_ORDER",
    CMD_MEDICINE_UPDATE = "CMD_MEDICINE_UPDATE",
    CMD_BLOCKDATA = "CMD_BLOCKDATA",
    CMD_PROCEDURESFORM = "CMD_PROCEDURESFORM",
    CMD_RECALLADMIN = "CMD_RECALLADMIN",
    CMD_DIAGNOSIS = "CMD_DIAGNOSIS",
    CMD_TREATMENTREASONS = "CMD_TREATMENTREASONS",
    CMD_REASONFORENCOUNTER = "CMD_REASONFORENCOUNTER",
    CMD_LANGUAGES = "CMD_LANGUAGES",
    CMD_COUNTRY = "CMD_COUNTRY",
    CMD_TEXT = "CMD_TEXT",
    CMD_CODEGROUP = "CMD_CODEGROUP",
    CMD_CODE = "CMD_CODE",
    CMD_EXIT = "CMD_EXIT",
    CMD_BILL_MENU = "CMD_BILL_MENU",
    CMD_BILL_AUTOMATIC = "CMD_BILL_AUTOMATIC",
    CMD_BILL_MANUALLY = "CMD_BILL_MANUALLY",
    CMD_COLLECTIVE_BILL = "CMD_COLLECTIVE_BILL",
    CMD_PAYMENTS_AUTOMATIC = "CMD_PAYMENTS_AUTOMATIC",
    CMD_PAYMENTS_MANUALLY = "CMD_PAYMENTS_MANUALLY",
    CMD_REMINDER_AUTOMATIC = "CMD_REMINDER_AUTOMATIC",
    CMD_REMINDER_MANUALLY = "CMD_REMINDER_MANUALLY",
    CMD_BILL_STORNIEREN = "CMD_BILL_STORNIEREN",
    CMD_INFORMATION_LIST = "CMD_INFORMATION_LIST",
    CMD_INKASSO_LISTE = "CMD_INKASSO_LISTE",
    CMD_BILL_JOURNAL = "CMD_BILL_JOURNAL",
    CMD_PAYMENT_JOURNAL = "CMD_PAYMENT_JOURNAL",
    CMD_OPEN_ITEM_LIST = "CMD_OPEN_ITEM_LIST",
    CMD_DUE_TREATMENTS = "CMD_DUE_TREATMENTS",
    CMD_DOCUMENT_COPIES = "CMD_DOCUMENT_COPIES",
    CMD_FTP_XML_TRANSFER = "CMD_FTP_XML_TRANSFER",
    CMD_XML_RESPONSE = "CMD_XML_RESPONSE",
    CMD_STATISTIC_MENU = "CMD_STATISTIC_MENU",
    CMD_STATISTIC_DAILY = "CMD_STATISTIC_DAILY",
    CMD_STATISTIC_DAILY_PERSONAL = "CMD_STATISTIC_DAILY_PERSONAL",
    CMD_STATISTIC_YEARLY_MENU = "CMD_STATISTIC_YEARLY_MENU",
    CMD_STATISTIC_YS_BILLS = "CMD_STATISTIC_YS_BILLS",
    CMD_STATISTIC_YS_TREATMENTS = "CMD_STATISTIC_YS_TREATMENTS",
    CMD_STATISTIC_PROCEDURE = "CMD_STATISTIC_PROCEDURE",
    CMD_STATISTIC_PATIENT_MENU = "CMD_STATISTIC_PATIENT_MENU",
    CMD_STATISTIC_PATIENT_DISTRIBUTION = "CMD_STATISTIC_PATIENT_DISTRIBUTION",
    CMD_STATISTIC_PATIENT_TREATMENTS = "CMD_STATISTIC_PATIENT_TREATMENTS",
    CMD_STATISTIC_MANDATE = "CMD_STATISTIC_MANDATE",
    CMD_OPTIONS_MENU = "CMD_OPTIONS_MENU",
    CMD_OPTIONS_LOGIN = "CMD_OPTIONS_LOGIN",
    CMD_OPTIONS_MANDATE = "CMD_OPTIONS_MANDATE",
    CMD_OPTIONS_WORKDATE = "CMD_OPTIONS_WORKDATE",
    CMD_OPTIONS_TREATER = "CMD_OPTIONS_TREATER",
    CMD_HELP = "CMD_HELP",
    CMD_ABOUT = "CMD_ABOUT",
    CMD_USER = "CMD_USER",
    CMD_TREATMENTMENAGMENT = "CMD_TREATMENTMENAGMENT",
    CMD_ADDRESS_ADMINISTARTION = "CMD_ADDRESS_ADMINISTARTION",
    CMD_TOOLS_MENU = "CMD_TOOLS_MENU",
    CMD_PRINTOUT = "CMD_PRINTOUT",
    CMD_HELPDATA = "CMD_HELPDATA",
    CMD_PRINTERCONF = "CMD_PRINTERCONF",
    CMD_PATIENTDOCS = "CMD_PATIENTDOCS",
    CMD_BILLDOCS = "CMD_BILLDOCS",
    CMD_MEDINDEXCONFIG = "CMD_MEDINDEXCONFIG",
    CMD_SASISCONFIG = "CMD_SASISCONFIG",
    CMD_ROCKETHEALTHCONFIG = "CMD_ROCKETHEALTHCONFIG",
    CMD_COSTCENTERS = "CMD_COSTCENTERS",
    CMD_COSTCENTER_SELECTION = "CMD_COSTCENTER_SELECTION",
    CMD_SUBCOSTCENTER_SELECTION = "CMD_SUBCOSTCENTER_SELECTION",
}

export enum FavoriteEntryType {
    PROCEDURE = "PROCEDURE",
    BLOCK_PROCEDURE = "BLOCK_PROCEDURE",
    MEDICAMENT = "MEDICAMENT",
}

export enum FileArchiveSourceType {
    BILL_XML_REQUEST = "BILL_XML_REQUEST",
    BILL_XML_RESPONSE = "BILL_XML_RESPONSE",
    BILL_XML_REQUEST_NOTIFICATION = "BILL_XML_REQUEST_NOTIFICATION",
    AUTOMATIC_BILL_RUN = "AUTOMATIC_BILL_RUN",
    PATIENT_RECORD_VACCINATION = "PATIENT_RECORD_VACCINATION",
    VMDL_EXPORT = "VMDL_EXPORT",
    VMDL_DOWNSTREAM = "VMDL_DOWNSTREAM",
    EMAIL = "EMAIL",
    NOTIFICATION_REPORT = "NOTIFICATION_REPORT",
    PATIENT_MEDICAL_DOCUMENT = "PATIENT_MEDICAL_DOCUMENT",
    CDR_DOCUMENT_DRAFT = "CDR_DOCUMENT_DRAFT",
    TEST_CERTIFICATE = "TEST_CERTIFICATE",
    TEST_RESULT = "TEST_RESULT",
    TREATER_SIGNATURE = "TREATER_SIGNATURE",
}

export enum InsuranceAcceptance {
    SPECIALITY_LIST = "SPECIALITY_LIST",
    NEGATIVE_LIST = "NEGATIVE_LIST",
    NON_NEGATIVE_NO_SPECIALITY = "NON_NEGATIVE_NO_SPECIALITY",
    REST = "REST",
}

export enum LabInvoiceTo {
    GUARANTOR = "GUARANTOR",
    PROVIDER = "PROVIDER",
}

export enum LanguageLocale {
    GERMAN = "GERMAN",
    ENGLISH = "ENGLISH",
    FRENCH = "FRENCH",
    ITALIAN = "ITALIAN",
}

export enum LockCode {
    MEDIDATA_UPDATE_DOWNLOADS = "MEDIDATA_UPDATE_DOWNLOADS",
    MEDIDATA_UPDATE_REMOTE_STATUS = "MEDIDATA_UPDATE_REMOTE_STATUS",
}

export enum LockStatus {
    OPEN = "OPEN",
    LOCKED = "LOCKED",
}

export enum MediDataResponseStatus {
    RECEIVED = "RECEIVED",
    CONFIRMED = "CONFIRMED",
    CLOSED = "CLOSED",
}

export enum Module {
    MODULE_PATIENT_CENTRAL = "MODULE_PATIENT_CENTRAL",
    MODULE_BILLING = "MODULE_BILLING",
    MODULE_CDR = "MODULE_CDR",
    MODULE_VACCINATION = "MODULE_VACCINATION",
    MODULE_LAB = "MODULE_LAB",
    MODULE_TESTING = "MODULE_TESTING",
    MODULE_HOME = "MODULE_HOME",
    MODULE_SETTINGS = "MODULE_SETTINGS",
    MODULE_GUARANTORS = "MODULE_GUARANTORS",
    MODULE_DOCTORS = "MODULE_DOCTORS",
    MODULE_TARIFF = "MODULE_TARIFF",
    MODULE_MEDICINES_MATERIALS = "MODULE_MEDICINES_MATERIALS",
    MODULE_USER_SETTINGS = "MODULE_USER_SETTINGS",
}

export enum NotificationReportType {
    TEST_POSITIVE = "TEST_POSITIVE",
    TEST_NEGATIVE = "TEST_NEGATIVE",
}

export enum NotificationType {
    EMAIL = "EMAIL",
    MANUAL = "MANUAL",
}

export enum OrderAdministrationOrderStatus {
    CREATED = "CREATED",
    SENT = "SENT",
    COMPLETED = "COMPLETED",
}

export enum OrderAdministrationSearchBy {
    SUPPLIER = "SUPPLIER",
    DATE_RANGE = "DATE_RANGE",
    SUPPLIER_AND_CREATED = "SUPPLIER_AND_CREATED",
}

export enum OrderStatus {
    ORDER = "ORDER",
    DELIVER = "DELIVER",
    REGISTERED = "REGISTERED",
    CANCEL = "CANCEL",
}

export enum OtpDuration {
    TWELVE_HOURS = "TWELVE_HOURS",
    SIX_MONTHS = "SIX_MONTHS",
}

export enum PatientDocumentOwnerEntity {
    TREATMENT = "TREATMENT",
    INTERVENTION = "INTERVENTION",
}

export enum PatientEmailRemoteStatus {
    DELIVERED = "DELIVERED",
    BOUNCED = "BOUNCED",
}

export enum PatientEmailSendStatus {
    REQUESTED = "REQUESTED",
    SENT = "SENT",
    SEND_ERROR = "SEND_ERROR",
    CANCELED = "CANCELED",
}

export enum PatientReportType {
    SYNOPSIS = "SYNOPSIS",
    PHYSIOTHERAPY = "PHYSIOTHERAPY",
}

export enum PaymentJournalPaymentType {
    ALL = "ALL",
    NORMAL = "NORMAL",
    CASH = "CASH",
}

export enum PaymentMethod {
    CREDIT_CARD = "CREDIT_CARD",
    TWINT = "TWINT",
    CASH = "CASH",
    INVOICE_GUARANTOR = "INVOICE_GUARANTOR",
    INVOICE_PATIENT = "INVOICE_PATIENT",
}

export enum PaymentStatus {
    INITIALIZED = "INITIALIZED",
    ERROR = "ERROR",
    CANCELLED = "CANCELLED",
    EXECUTED = "EXECUTED",
}

export enum PaymentType {
    NORMAL = "NORMAL",
    OVERPAID = "OVERPAID",
    LESS_PAID = "LESS_PAID",
}

export enum PhysiotherapyTreatmentGoal {
    ANALGESIA_OR_ANTI_INFLAMMATORY = "ANALGESIA_OR_ANTI_INFLAMMATORY",
    IMPROVEMENT_JOINT_FUNCTION = "IMPROVEMENT_JOINT_FUNCTION",
    IMPROVEMENT_MUSCLE_FUNCTION = "IMPROVEMENT_MUSCLE_FUNCTION",
    PROPRIOCEPTION_OR_COORDINATION = "PROPRIOCEPTION_OR_COORDINATION",
    IMPROVEMENT_CARDIOPULMONARY_FUNCTION = "IMPROVEMENT_CARDIOPULMONARY_FUNCTION",
    DECONGESTION = "DECONGESTION",
    PARTICULAR = "PARTICULAR",
    FUNCTIONAL_ASSOCIATION = "FUNCTIONAL_ASSOCIATION",
    BREIFING = "BREIFING",
    OTHER = "OTHER",
}

export enum PhysiotherapyTreatmentPrescription {
    FIRST = "FIRST",
    SECOND = "SECOND",
    THIRD = "THIRD",
    FOURTH = "FOURTH",
    LONG_TERM = "LONG_TERM",
}

export enum PhysiotherapyTreatmentsNumber {
    HOME_TREATMENT = "HOME_TREATMENT",
    TWO_TREATMENTS_PER_DAY = "TWO_TREATMENTS_PER_DAY",
    MEDICAL_CHECK_UP = "MEDICAL_CHECK_UP",
}

export enum PrintOrientation {
    LANDSCAPE = "LANDSCAPE",
    PORTRAIT = "PORTRAIT",
}

export enum PrintoutConfiguration {
    PREDEFINED = "PREDEFINED",
    USERDEFINED = "USERDEFINED",
}

export enum PrintoutPredefinedType {
    HORIZONTAL = "HORIZONTAL",
    VERTICAL_LONG = "VERTICAL_LONG",
    VERTICAL_SHORT = "VERTICAL_SHORT",
    SPITEXT = "SPITEXT",
}

export enum Privilege {
    PX_CORE_HOME = "PX_CORE_HOME",
    PX_CORE_BILLS = "PX_CORE_BILLS",
    PX_CORE_BILLS_XML = "PX_CORE_BILLS_XML",
    PX_CORE_MISANTO_IMPORT = "PX_CORE_MISANTO_IMPORT",
    PX_CORE_PATIENT_CENTRAL = "PX_CORE_PATIENT_CENTRAL",
    PX_CORE_DASHBOARD = "PX_CORE_DASHBOARD",
    PX_CORE_GUARANTORS_CONFIGURATION = "PX_CORE_GUARANTORS_CONFIGURATION",
    PX_CORE_DOCTORS_CONFIGURATION = "PX_CORE_DOCTORS_CONFIGURATION",
    PX_CORE_TARIFFS_CONFIGURATION = "PX_CORE_TARIFFS_CONFIGURATION",
    PX_CORE_MEDICINES_MATERIALS_CONFIGURATION = "PX_CORE_MEDICINES_MATERIALS_CONFIGURATION",
    PX_CORE_REFERENCE_DATA_CONFIGURATION = "PX_CORE_REFERENCE_DATA_CONFIGURATION",
    PX_CORE_USER_SETTINGS_CONFIGURATION = "PX_CORE_USER_SETTINGS_CONFIGURATION",
    PX_CORE_SETTINGS_VMDL = "PX_CORE_SETTINGS_VMDL",
    PX_CORE_USERS = "PX_CORE_USERS",
    PX_CORE_FIX_CC_PAYMENTS = "PX_CORE_FIX_CC_PAYMENTS",
    PX_CORE_POPULATE_HISTORY_USER_IDS = "PX_CORE_POPULATE_HISTORY_USER_IDS",
    PX_CORE_MIPICO_IMPERSONATIONS = "PX_CORE_MIPICO_IMPERSONATIONS",
    PX_AGENDA_MANDATE_APPOINTMENTS = "PX_AGENDA_MANDATE_APPOINTMENTS",
    PX_CORE_STOCK_MANAGEMENT = "PX_CORE_STOCK_MANAGEMENT",
    PX_CORE_CLINICAL_DATA_RECORD = "PX_CORE_CLINICAL_DATA_RECORD",
    PX_CORE_TEST_CHECK_IN = "PX_CORE_TEST_CHECK_IN",
    PX_CORE_SET_TEST_RESULT = "PX_CORE_SET_TEST_RESULT",
    PX_CORE_VERIFY_TEST_RESULT = "PX_CORE_VERIFY_TEST_RESULT",
    PX_CORE_LAB_CENTRAL = "PX_CORE_LAB_CENTRAL",
    PX_CORE_PATIENT_MERGE = "PX_CORE_PATIENT_MERGE",
    PX_CORE_SET_CONTROLLED_BY_STATUS = "PX_CORE_SET_CONTROLLED_BY_STATUS",
    PX_CORE_GENERATE_RANDOM_MSNT_CODE = "PX_CORE_GENERATE_RANDOM_MSNT_CODE",
    PX_CORE_CAN_VIEW_REQUIRES_DOCTOR_ACTION_NOTIFICATIONS = "PX_CORE_CAN_VIEW_REQUIRES_DOCTOR_ACTION_NOTIFICATIONS",
    PX_CORE_ARCHIVE_REJECTED_BILL_AND_RECREATE_XML = "PX_CORE_ARCHIVE_REJECTED_BILL_AND_RECREATE_XML",
    PX_CORE_UNABLE_TO_WORK_OR_PRESCRIPTION_REPORT = "PX_CORE_UNABLE_TO_WORK_OR_PRESCRIPTION_REPORT",
}

export enum ProcedureStatisticSortBy {
    PROCEDURE_CODE = "PROCEDURE_CODE",
    TIME = "TIME",
}

export enum ProcedureType {
    TP = "TP",
    CHF = "CHF",
}

export enum ProceduresProtocolSortBy {
    TIME = "TIME",
    PATIENT_NAME = "PATIENT_NAME",
}

export enum QuestionKey {
    PRE_1 = "PRE_1",
    HEALTHPROVIDER_2 = "HEALTHPROVIDER_2",
    ENDANGEREDINSTITUTION_3 = "ENDANGEREDINSTITUTION_3",
    ENDANGEREDPERSON_4 = "ENDANGEREDPERSON_4",
    AGE_VUNERA_9 = "AGE_VUNERA_9",
}

export enum ReportKey {
    BILL = "BILL",
    BILLVERTICAL = "BILLVERTICAL",
    BILLVERTICALESR = "BILLVERTICALESR",
    BILLVERTICAL_SHORT = "BILLVERTICAL_SHORT",
    BILL_PROOF_LIST_DETAIL_TOTAL = "BILL_PROOF_LIST_DETAIL_TOTAL",
    BILL_PROOF_LIST_DETAIL_PART = "BILL_PROOF_LIST_DETAIL_PART",
    BILL_PROOF_LIST = "BILL_PROOF_LIST",
    COLLECTIVE_BILL = "COLLECTIVE_BILL",
    COLLECTIVE_PART_BILL = "COLLECTIVE_PART_BILL",
    REMINDER_PROOF_LIST = "REMINDER_PROOF_LIST",
    REMINDER = "REMINDER",
    REMINDERVERTICAL = "REMINDERVERTICAL",
    REMINDERVERTICALESR = "REMINDERVERTICALESR",
    REMINDERVERTICAL_SHORT = "REMINDERVERTICAL_SHORT",
    BILL_INFORMATION_LIST = "BILL_INFORMATION_LIST",
    INKASSO_LIST = "INKASSO_LIST",
    RECALL = "RECALL",
    RECALL_LIST = "RECALL_LIST",
    PAYMENT_PROOF_LIST = "PAYMENT_PROOF_LIST",
    STORNO_PROOF_LIST = "STORNO_PROOF_LIST",
    PATIENT_LETTER = "PATIENT_LETTER",
    BILL_JOURNAL = "BILL_JOURNAL",
    PAYMENT_JOURNAL = "PAYMENT_JOURNAL",
    OPEN_ITEM_LIST = "OPEN_ITEM_LIST",
    DUE_TREATMENTS = "DUE_TREATMENTS",
    PATIENT_BILL_INFORMATION = "PATIENT_BILL_INFORMATION",
    MANDATE_PRINT = "MANDATE_PRINT",
    COST_ESTIMATION_LIST = "COST_ESTIMATION_LIST",
    TARMED_LIST = "TARMED_LIST",
    ADDRESS_LIST = "ADDRESS_LIST",
    ADDRESS_PATIENT_LIST = "ADDRESS_PATIENT_LIST",
    ADDRESS_GUARANTOR_LIST = "ADDRESS_GUARANTOR_LIST",
    ADDRESS_DOCTOR_LIST = "ADDRESS_DOCTOR_LIST",
    ADDRESS_SUPPLIER_LIST = "ADDRESS_SUPPLIER_LIST",
    ADDRESS_PHONE_LIST = "ADDRESS_PHONE_LIST",
    ADDRESS_PATIENT_PHONE_LIST = "ADDRESS_PATIENT_PHONE_LIST",
    ADDRESS_GUARANTOR_PHONE_LIST = "ADDRESS_GUARANTOR_PHONE_LIST",
    ADDRESS_DOCTOR_PHONE_LIST = "ADDRESS_DOCTOR_PHONE_LIST",
    ADDRESS_SUPPLIER_PHONE_LIST = "ADDRESS_SUPPLIER_PHONE_LIST",
    LABELS_LIST = "LABELS_LIST",
    PATIENT_LABELS_LIST = "PATIENT_LABELS_LIST",
    GUARANTOR_LABELS_LIST = "GUARANTOR_LABELS_LIST",
    DOCTOR_LABELS_LIST = "DOCTOR_LABELS_LIST",
    SUPPLIER_LABELS_LIST = "SUPPLIER_LABELS_LIST",
    COVERT = "COVERT",
    PATIENT_COVERT = "PATIENT_COVERT",
    GUARANTOR_COVERT = "GUARANTOR_COVERT",
    DOCTOR_COVERT = "DOCTOR_COVERT",
    SUPPLIER_COVERT = "SUPPLIER_COVERT",
    STOCK_ADMINISTRATION_LIST = "STOCK_ADMINISTRATION_LIST",
    ORDER_ADMINISTRATION_LIST = "ORDER_ADMINISTRATION_LIST",
    TARMED_PROCEDURES_LIST = "TARMED_PROCEDURES_LIST",
    SECTION_AND_DIGNITY = "SECTION_AND_DIGNITY",
    TARMED_XML_RESPONSE = "TARMED_XML_RESPONSE",
    PATIENT_UNABLE_TO_WORK_ID = "PATIENT_UNABLE_TO_WORK_ID",
    PRESCRIPTION_ID = "PRESCRIPTION_ID",
    POOL_TEST_SHIPPING_ADDRESS_LABEL_ID = "POOL_TEST_SHIPPING_ADDRESS_LABEL_ID",
    COVID_TEST_BARCODE_LABEL_ID = "COVID_TEST_BARCODE_LABEL_ID",
    COVID_PCR_TEST_CERTIFICATE_ID = "COVID_PCR_TEST_CERTIFICATE_ID",
    COVID_PCR_TEST_POSITIVE_CERTIFICATE_ID = "COVID_PCR_TEST_POSITIVE_CERTIFICATE_ID",
    COVID_RAPID_TEST_CERTIFICATE_ID = "COVID_RAPID_TEST_CERTIFICATE_ID",
    COVID_RAPID_TEST_POSITIVE_CERTIFICATE_ID = "COVID_RAPID_TEST_POSITIVE_CERTIFICATE_ID",
    HPV_TEST_REPORT_ID = "HPV_TEST_REPORT_ID",
    GENERIC_LAB_TEST_REPORT_ID = "GENERIC_LAB_TEST_REPORT_ID",
    QUESTION_TEST_REPORT_ID = "QUESTION_TEST_REPORT_ID",
    PATIENT_SYNOPSIS_REPORT_ID = "PATIENT_SYNOPSIS_REPORT_ID",
    PATIENT_PHYSIOTHERAPY_REPORT_ID = "PATIENT_PHYSIOTHERAPY_REPORT_ID",
    DOCTOR_REPORT_ID = "DOCTOR_REPORT_ID",
    PATIENT_MEDICAMENT_LABEL_ID = "PATIENT_MEDICAMENT_LABEL_ID",
}

export enum ReportType {
    BILL = "BILL",
    BILL_VERTICAL = "BILL_VERTICAL",
    BILL_VERTICAL_ESR = "BILL_VERTICAL_ESR",
    BILL_VERTICAL_SHORT = "BILL_VERTICAL_SHORT",
    REMINDER = "REMINDER",
    TARMED_LIST = "TARMED_LIST",
    REMINDER_VERTICAL = "REMINDER_VERTICAL",
    REMINDER_VERTICAL_ESR = "REMINDER_VERTICAL_ESR",
    REMINDER_VERTICAL_SHORT = "REMINDER_VERTICAL_SHORT",
    TARMED_XML_RESPONSE = "TARMED_XML_RESPONSE",
    LAST = "LAST",
}

export enum ScaleType {
    QN = "QN",
    ORD = "ORD",
    NAR = "NAR",
}

export enum SpecialCase {
    SINGULARIZATION = "SINGULARIZATION",
    POSITIVE_RESULT_NO_POOLING_POSSIBLE = "POSITIVE_RESULT_NO_POOLING_POSSIBLE",
    NO_POOL_AVAILABLE = "NO_POOL_AVAILABLE",
    COMPANY_SELF_PAYER = "COMPANY_SELF_PAYER",
    OUTBREAK_TESTING = "OUTBREAK_TESTING",
}

export enum StockAdministrationSearchBy {
    ALL = "ALL",
    IN_STOCK = "IN_STOCK",
    LOW_QUANTITY = "LOW_QUANTITY",
    NOT_MANAGED = "NOT_MANAGED",
}

export enum StorageType {
    NO_LIMIT = "NO_LIMIT",
    IN_REFRIGERATOR = "IN_REFRIGERATOR",
    IN_FREEZER = "IN_FREEZER",
    BETAUBUNGSMITTEL = "BETAUBUNGSMITTEL",
    POISON = "POISON",
}

export enum StornoType {
    BILL = "BILL",
    PAYMENT = "PAYMENT",
}

export enum SynopsisAbsence {
    FILE_STUDY_IN_ABSENCE = "FILE_STUDY_IN_ABSENCE",
    INFORMATION_ABOUT_RELATIVES_OR_OTHER_CAREGIVERS = "INFORMATION_ABOUT_RELATIVES_OR_OTHER_CAREGIVERS",
    MEETINGS_WITH_THERAPIST_AND_CAREGIVERS = "MEETINGS_WITH_THERAPIST_AND_CAREGIVERS",
    REFERRALS_TO_CONSULTANT_PHYSICIANS = "REFERRALS_TO_CONSULTANT_PHYSICIANS",
    ISSUING_PRESCRIPTIONS_OR_ORDERS = "ISSUING_PRESCRIPTIONS_OR_ORDERS",
    REGISTRATION_RONTGEN_CT_MRI_ULTRASONIC = "REGISTRATION_RONTGEN_CT_MRI_ULTRASONIC",
    PHYSIOTHERAPY_REGULATION = "PHYSIOTHERAPY_REGULATION",
    INTERNAL_TRANSFER = "INTERNAL_TRANSFER",
    ISSUING_RECIPES = "ISSUING_RECIPES",
    ISSUIN_CERTIFICAT_OF_INABILITY_TO_WORK = "ISSUIN_CERTIFICAT_OF_INABILITY_TO_WORK",
    PREPARING_MEDICAL_REPORT = "PREPARING_MEDICAL_REPORT",
    OTHER = "OTHER",
}

export enum SynopsisReasons {
    EMERGENCY = "EMERGENCY",
    INCREASED_NEED_FOR_TREATMENT = "INCREASED_NEED_FOR_TREATMENT",
    CONSULTATION = "CONSULTATION",
    VISIT = "VISIT",
    TELEPHONE_CONSULTATION = "TELEPHONE_CONSULTATION",
    SMALL_INVESTIGATION = "SMALL_INVESTIGATION",
    COMPREHENSIVE_INVESTIGATION = "COMPREHENSIVE_INVESTIGATION",
    SPECIFIC_ADVICE_FROM_THE_SPECIALIST = "SPECIFIC_ADVICE_FROM_THE_SPECIALIST",
    PSYCHOTHERAPEUTIC_PSYCHOSOCIAL_COUNSELING = "PSYCHOTHERAPEUTIC_PSYCHOSOCIAL_COUNSELING",
    INSTRUCTION_OF_SELF_MEASUREMENTS_SELF_TREATMENT = "INSTRUCTION_OF_SELF_MEASUREMENTS_SELF_TREATMENT",
    WOUND_CARE = "WOUND_CARE",
    VACCINATION = "VACCINATION",
    BLOOD_COLLECTION = "BLOOD_COLLECTION",
    URINE_COLLECTION = "URINE_COLLECTION",
    OTHER = "OTHER",
}

export enum TariffCode {
    TARMED = "TARMED",
    TARDOC = "TARDOC",
    PHYSIO = "PHYSIO",
    PHYSIO_312 = "PHYSIO_312",
    LABOR = "LABOR",
    LABOR_317 = "LABOR_317",
    PANDEMIC = "PANDEMIC",
    MEDICINE = "MEDICINE",
    MEDICINE_401 = "MEDICINE_401",
    MEDICINE_402 = "MEDICINE_402",
    MEDICINE_403 = "MEDICINE_403",
    MEDICINE_404 = "MEDICINE_404",
    COVID = "COVID",
    MEDICINE_408 = "MEDICINE_408",
    MEDICINE_410 = "MEDICINE_410",
    ROUNDING = "ROUNDING",
    MATERIAL = "MATERIAL",
    MIGEL = "MIGEL",
    SPITEX = "SPITEX",
    COMPLEMENTARY_MEDICINE = "COMPLEMENTARY_MEDICINE",
    UNKNOWN = "UNKNOWN",
    ZAHNLEISTUNGEN = "ZAHNLEISTUNGEN",
    ZAHNTECHNIK = "ZAHNTECHNIK",
    OTHER = "OTHER",
}

export enum TariffType {
    KVG = "KVG",
    UVG = "UVG",
    IVG = "IVG",
    VVG = "VVG",
    MVG = "MVG",
}

export enum TreatmentStatus {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
}

export enum TreatmentsOrderBy {
    TREATMENT_DATE = "TREATMENT_DATE",
    PATIENT_NAME = "PATIENT_NAME",
    GUARANTOR_NAME = "GUARANTOR_NAME",
}

export enum Urgency {
    LOW = "LOW",
    NORMAL = "NORMAL",
    HIGH = "HIGH",
}

export enum VaccinationImportIntervention {
    VACCINATION_DOSE_1 = "VACCINATION_DOSE_1",
    VACCINATION_DOSE_2 = "VACCINATION_DOSE_2",
    VACCINATION_BOOSTER = "VACCINATION_BOOSTER",
    VACCINATION_SINGLE_DOSE = "VACCINATION_SINGLE_DOSE",
}

export enum VatType {
    VAT_TYPE_INCL = "VAT_TYPE_INCL",
    VAT_TYPE_EXCL = "VAT_TYPE_EXCL",
}

export enum VerifyEmailStatus {
    PENDING = "PENDING",
    ACCEPTED = "ACCEPTED",
    DECLINED = "DECLINED",
}

export enum VmdlExportStatus {
    SUCCESS = "SUCCESS",
    EMPTY_EXPORT = "EMPTY_EXPORT",
    ERROR = "ERROR",
}

export enum VmdlExportType {
    SCHEDULED = "SCHEDULED",
    MANUAL_EXPORT = "MANUAL_EXPORT",
    FILE_UPLOAD_ADD = "FILE_UPLOAD_ADD",
    FILE_UPLOAD_DELETE = "FILE_UPLOAD_DELETE",
    PROOF_LIST = "PROOF_LIST",
}

export enum WildcardPosition {
    SUFFIX = "SUFFIX",
    PREFIX = "PREFIX",
    SUFFIX_AND_PREFIX = "SUFFIX_AND_PREFIX",
}

export enum XmlReason {
    UNKNOWN = "UNKNOWN",
    PREVENTION = "PREVENTION",
    MATERNITY = "MATERNITY",
    DISEASE = "DISEASE",
    ACCIDENT = "ACCIDENT",
    BIRTH_DEFECT = "BIRTH_DEFECT",
}

export enum ZipDataOrderBy {
    ZIP = "ZIP",
    CITY = "CITY",
}

export enum PatientDocumentType {
    UNABLE_TO_WORK = "UNABLE_TO_WORK",
    PRESCRIPTION = "PRESCRIPTION",
    MEDICAL_REPORT_AND_DIAGNOSIS = "MEDICAL_REPORT_AND_DIAGNOSIS",
    AKTUELLE_MEDIKAMENTE = "AKTUELLE_MEDIKAMENTE",
    CERTIFICATE = "CERTIFICATE",
    VACCINATION_CERTIFICATE = "VACCINATION_CERTIFICATE",
    LAB_RESULTS = "LAB_RESULTS",
    CT_AND_MRT = "CT_AND_MRT",
    EKG = "EKG",
    X_RAY = "X_RAY",
    RECIPE = "RECIPE",
    BILL = "BILL",
    PATIENT_SYNOPSIS_REPORT = "PATIENT_SYNOPSIS_REPORT",
    PATIENT_PHYSIOTHERAPY_REPORT = "PATIENT_PHYSIOTHERAPY_REPORT",
    DOCTOR_REPORT = "DOCTOR_REPORT",
    INTERVENTION_REPORT = "INTERVENTION_REPORT",
    OTHER = "OTHER",
}

export enum PatientReportStatus {
    PREPARED = "PREPARED",
    CONTROLLED = "CONTROLLED",
}

export enum TestResultStatus {
    VALID = "VALID",
    REVOKED = "REVOKED",
    IN_PROGRESS = "IN_PROGRESS",
}
